module.exports = __webpack_public_path__ + "img/reactjs.e7c46a28.svg";